export const CLASS_OPEN = 'is-bundle-builder-open';

const getOrderSummary = () => {
  const template = document.createElement('template');
  const maxWidthAndHeightOfIcon = 27;

  template.innerHTML = `
    <style>
      :host {
        background: #F5F2F0;
        padding: 40px 20px 0;
        display: block;
      }

      .o-customiser__summary {
        background: #F5F2F0;
      }

      .o-customiser__step-title {
        font-family: Recoleta, sans-serif;
        font-size: 2rem;
        font-weight: 500;
        line-height: 2.5rem;
        margin: 0 0 2rem;
        text-align: center;
      }

      .o-customiser__summary-item {
        display: flex;
        border-radius: 1rem;
        padding: 1.25rem 1.5rem;
        align-items: center;
        background: #FCFCFB;
        margin-bottom: 1rem;
      }

      .o-customiser__summary-item:last-child {
        margin-bottom: 0;
      }

      .o-customiser__summary-icon {
        width: 2.25rem;
        height: 2.25rem;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        margin-right: 1.25rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }

      .o-customiser__summary-icon img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .o-customiser__summary-text {
        font-family: "TTNorms Font", sans-serif;
        font-size: .875rem;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: .0175rem;
        color: #163021;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: .25rem;
      }

      .o-customiser__summary-text-value {
        color: #3F7355;
      }

      .o-customiser__summary-edit {
        margin-left: auto;
        display: flex;
        align-items: center;
        color: #7C8D80;
        padding: 0;
        border: none;
        background: none;
        cursor: pointer;
      }

      .o-customiser__summary-edit:hover .o-customiser__summary-edit-text {
        color: #163021;
      }

      .o-customiser__summary-edit:hover .o-customiser__summary-edit-icon path {
        stroke: #163021;
      }

      .o-customiser__summary-edit-text {
        padding-left: 1.25rem;
        display: inline-block;
        font-family: "TTNorms Font", sans-serif;
        font-size: .8125rem;
        font-weight: 400;
        line-height: 1.25rem;
      }

      .o-customiser__summary-edit-icon {
        width: .875rem;
        margin-left: .375rem;
      }

      .ratio-icon {
        transition: all 1s 0.3s;
        display: block;
        width: var(--icon-width);
        height: var(--icon-drop);
        max-width: ${maxWidthAndHeightOfIcon}px;
        max-height: ${maxWidthAndHeightOfIcon}px;
        background:
          linear-gradient(to right, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 0 0,
          linear-gradient(to right, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 0 100%,
          linear-gradient(to left, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 100% 0,
          linear-gradient(to left, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 100% 100%,
          linear-gradient(to bottom, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 0 0,
          linear-gradient(to bottom, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 100% 0,
          linear-gradient(to top, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 0 100%,
          linear-gradient(to top, #7C8D80 var(--icon-border-weight), transparent var(--icon-border-weight)) 100% 100%;
      
        background-repeat: no-repeat;
        background-size: var(--icon-border-length) var(--icon-border-length);
      }

      @media only screen and (min-width: 1100px) {

        :host {
          grid-column: 1 / 2;
          padding: 3.875rem 0 0;
          width: calc(100vw - 40.75rem);
        }

        .o-customiser__step-title {
          font-size: 2rem;
          line-height: 2.5rem;
          margin: 0 0 2rem;
          text-align: left;
        }
  
        .o-customiser__summary-item {
          display: flex;
          border-radius: 1rem;
          padding: 1.25rem 1.5625rem 1.25rem 1.25rem;
          align-items: center;
          background: #FCFCFB;
          margin-bottom: 1rem;
        }
  
        .o-customiser__summary-item:last-child {
          margin-bottom: 0;
        }
  
        .o-customiser__summary-icon {
          width: 2.25rem;
          height: 2.25rem;
          border-radius: 50%;
          overflow: hidden;
          position: relative;
          margin-right: 1.25rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }
  
        .o-customiser__summary-icon img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
  
        .o-customiser__summary-text {
          font-family: "TTNorms Font", sans-serif;
          font-size: 1rem;
          font-weight: 500;
          line-height: 1.5rem;
          letter-spacing: .02rem;
          color: #163021;
          display: flex;
          gap: .375rem;
        }
  
        .o-customiser__summary-edit-text {
          padding-left: 1.25rem;
          font-size: .875rem;
          line-height: 1.25rem;
        }
  
        .o-customiser__summary-edit-icon {
          width: 1.125rem;
          margin-left: .5rem;
        }

      }


      @media only screen and (min-width: 1750px) {

        :host {
          width: calc(100vw - 56rem);
        }


        .o-customiser__summary-text {
          font-size: 1.125rem;
          line-height: 1.5rem;
        }

        .o-customiser__summary-edit-text {
          font-size: 1rem;
          line-height: 1.5rem;
        }
  
        .o-customiser__summary-edit-icon {
          width: 1.25rem;
          margin-left: .5rem;
        }
      }

    </style>

    <div class="o-customiser__summary">

      <h2 class="o-customiser__step-title">Confirm your order</h2>

      <div class="o-customiser__summary" data-summary-items></div>

    </div>

    <div class="o-customiser__add-cart" part="root">
      <slot></slot>
    </div>
  `;
    
  return template;
}

const getSummaryItemMarkup = section => {
  if (!section || section.value === undefined) return;
  
  let dataTitle = section.value;

  if (section.title == 'Colour') {
    const colorNameSplit = section.value.split('-');
    dataTitle = colorNameSplit[colorNameSplit.length - 1].trim();
  }
  
  return `
    <div class="o-customiser__summary-item">
      <div class="o-customiser__summary-icon">
        ${section.image ? section.image : ''}
      </div>
      <div class="o-customiser__summary-text">
        <span>${section.title}</span>
        <span class="o-customiser__summary-text-value">${dataTitle}</span>
      </div>
      <button class="o-customiser__summary-edit" data-summary-item-edit step-id="${section.step_id}">
        <span class="o-customiser__summary-edit-text">Edit</span>
        <svg class="o-customiser__summary-edit-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path stroke="currentColor" d="M16.544 1.456a.998.998 0 0 0-1.412 0l-7.97 7.97a3 3 0 0 0-.725 1.172l-.355 1.067a.2.2 0 0 0 .253.253l1.066-.356a3 3 0 0 0 1.173-.724l7.97-7.97a.998.998 0 0 0 0-1.412Z"/> <path stroke="currentColor" stroke-linecap="round" d="M10.5 3H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.5"/></svg>
      </button>
    </div>
  `
}

export class CustomiserOrderSummary extends HTMLElement {

  constructor() {
    super();

    const shadowRoot = this.attachShadow({ mode: 'open' });
    const template = getOrderSummary();
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.addEventListener('click', this.handleClick);
  }

  private handleClick(e) {
    // Click event handled via Event Delegation
    // because the individual elements are contantly rerendered
    const eventPath = e.composedPath();

    const elemWithStepId = eventPath.find(elem => {
      // Need top optionally chain the function call
      // composed path sometimes has shadow-root, which is an element, 
      // but doesn't have getAttribute
      return !!elem?.getAttribute?.('step-id') 
    });

    if (elemWithStepId) {
      const evt = new CustomEvent('scroll_parent', {
        detail: {
          stepId: elemWithStepId.getAttribute('step-id')
        },
        bubbles: true
      });

      this.dispatchEvent(evt);
    }
  }

  public updateOrderSummary(data: any) {
    const summaryContainer = this.shadowRoot?.querySelector('[data-summary-items]');

    if (!summaryContainer) return;

    // Clear existing summary items
    summaryContainer.innerHTML = '';

    const itemMarkup = data.map(getSummaryItemMarkup).join('')
    summaryContainer.insertAdjacentHTML('beforeend', itemMarkup);

  }
}

if (!customElements.get('customiser-order-summary')) {
  customElements.define('customiser-order-summary', CustomiserOrderSummary);
}